<template>
  <div class="ma3 ma4-l mb4">
    <details-section class="mt4">
      <template #header>
        Реквизиты
      </template>
      <template #content>
        <!--
        тут, возможно, нужен цикл по полям стейта, но перед этим надо сформировать их порядок в беке
        -->
        <live-field :field="state.title" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.number" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field"  @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.contract_id" :save="updateState" #default="{ field, update, saving }">
          <reference-field :entity="entity" :state="state" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving" />
        </live-field>
        <live-field :field="state.counteragent_company_id" :save="updateState" #default="{ field, update, saving }">
          <reference-field :entity="entity" :state="state" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving" />
        </live-field>
        <live-field :field="state.counteragent_user_id" :save="updateState" #default="{ field, update, saving }">
          <reference-field :entity="entity" :state="state" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving" />
        </live-field>
        <live-field :field="state.start_at" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.delivery_at" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.reject_reason" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
      </template>
    </details-section>

    <details-section class="mt4">
      <template #header>
        Позиции
      </template>
      <template #content>
        <live-field :field="state.delivery_address" :save="updateState" #default="{ field, update, saving }">
          <text-field :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.vat" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.currency_id" :save="updateState" #default="{ field, update, saving }">
          <reference-field :entity="entity" :state="state" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving" />
        </live-field>

        <positions-section
          :id='id'
          :out="out"
          :state="state"
          :actors="actors"
          class="bg-white mt4"
        />
      </template>
    </details-section>

  </div>
</template>

<script>
import DetailsSection from '@/components/common/CardDetailsSection.vue'

// можно использовать разные темплейты для UI организации полей ввода
import Horizontal from '@/components/common/form/templates/Horizontal.vue'
import Vertical from '@/components/common/form/templates/Vertical.vue'

import LiveField from '@/components/common/form/LiveField.vue'
import IntegerField from '@/components/common/form/scalar/IntegerField.vue'
import StringField from '@/components/common/form/scalar/StringField.vue'
import TextField from '@/components/common/form/scalar/TextField.vue'
import BooleanField from '@/components/common/form/scalar/BooleanField.vue'
import DatetimeField from '@/components/common/form/scalar/DatetimeField.vue'
import DecimalField from '@/components/common/form/scalar/DecimalField.vue'
import ReferenceField from '@/components/common/form/ReferenceField.vue'

import PositionsSection from '@/components/common/PositionsSection.vue'

import { DataService } from '@/services/DataService.js'

export default {
  props: ['id', 'out', 'state', 'updateState'],
  components: {
    DetailsSection,
    Horizontal,
    Vertical,
    LiveField,
    IntegerField,
    StringField,
    TextField,
    BooleanField,
    DatetimeField,
    DecimalField,
    ReferenceField,
    PositionsSection
  },
  computed: {
    loadPositionsParams () {
      return {
        filter: { order_id: this.id }
      }
    }
  },
  data () {
    return {
      fieldTemplate: Horizontal, // Vertical
      entity: { id: this.id, name: 'order' },
      actors: {
        loadPositions: {
          title: 'Загрузить позиции',
          enabled: (actions, positions) => true,
          callback: async (params) => {
            const extParams = { ...params, filter: { ...params.filter, order_id: this.id } }
            return DataService.getOrderPositions(extParams).then((p) => {
              return p
            })
          }
        },
        appendParentPositions: {
          title: 'Добавить позиции договора',
          enabled: (actions, positions) => {
            return actions &&
              actions.create &&
              this.state.contract_id.value
          },
          callback: async () => {
            const params = {
              order_id: this.id,
              contract_id: this.state.contract_id.value
            }
            return DataService.appendContractPositions(params)
          }
        },
        removeAllPositions: {
          title: 'Удалить все позиции',
          enabled: (actions, positions) => {
            return actions && actions.delete && positions && positions.length > 0
          },
          callback: async () => {
            const params = { order_id: this.id }
            return DataService.removeOrderPositions(params)
          }
        },
        createPosition: {
          title: null,
          enabled: (actions, positions) => true,
          makeDraft: ({ id, name }) => {
            return {
              id: null,
              position_id: id,
              title: name,
              anno: null,
              amount: null,
              unit_id: null,
              price: null,
              vat: null,
              currency_id: null,
              delivery_within_days: null,
              vendor_code: null
            }
          },
          callback: async (position) => {
            delete position.__typename
            delete position.id
            const params = { order_id: this.id, input: position }
            return DataService.createOrderPosition(params)
              .then(({ data: { create_order_position: { position, errors } } }) => {
                return { position, errors }
              })
          }
        },
        updatePosition: {
          title: null,
          enabled: (actions, positions) => true,
          callback: async (position) => {
            const positionId = position.id
            delete position.__typename
            delete position.id
            delete position.contract_amount
            const params = { position_id: positionId, input: position }
            return DataService.updateOrderPosition(params)
              .then(({ data: { update_order_position: { position, errors } } }) => {
                return { position, errors }
              })
          }
        },
        deletePosition: {
          title: null,
          enabled: (actions, positions) => true,
          callback: ({ id }) => {
            return DataService.deleteOrderPosition({ id })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
